import DateUtil from '@/lib/ui/utils/date.util.js'

const FormDateSelect = {
  // 类型
  componentType: 'FORM_DATEPICK_INPUT',
  // 部件显示样式
  widgetConfig: {
    icon: 'x-lib-datepicker',
    text: '日期时间',
    optionTitle: true,
    description: '用于选择或输入日期、时间'
  },
  componentConfig: {
    uuid: `32bit uuid`,
    width: 6, // 3, 6, 9, 12
    height: 1,
    render: {
      ide: 'FormDateSelect',
      edit: 'FormDateSelect',
      read: 'FormDateSelect'
    },
    label: '日期时间',
    placeholder: '请选择日期',
    inTable: true,
    enableRule: false,
    methods: {
      lcInitData: {
        edit: (...args) => {
          console.log(args)
        }
      },
      lcConvertDefaultValue: (config) => {
        // ----------
        let type = config.defaultValue
        let nowDate = Date.now()
        let actuDate
        let oneDay = 24 * 60 * 60 * 1000
        console.log(new Date(nowDate - oneDay))
        if (type === 'Now') {
          actuDate = new Date(nowDate)
        } else if (type === 'Yesterday') {
          actuDate = new Date(nowDate - oneDay)
        } else if (type === 'Tomorrow') {
          actuDate = new Date(nowDate + oneDay)
        } else {
          if (type !== 'SpecifyTheDate') {
            return type
          }
        }
        // --------------------------
        let year = actuDate.getFullYear()
        let month = actuDate.getMonth() + 1
        let date = actuDate.getDate()
        let hour = actuDate.getHours()
        let minute = actuDate.getMinutes()
        let second = actuDate.getSeconds()
        if (month < 10) {
          month = '0' + month
        }
        if (date < 10) {
          date = '0' + date
        }
        if (hour < 10) {
          hour = '0' + hour
        }
        if (minute < 10) {
          minute = '0' + minute
        }
        if (second < 10) {
          second = '0' + second
        }
        console.log(year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second)
        if (config.dateDisplayStyle === 'DATE_TIME') {
          return year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
        } else {
          return year + '-' + month + '-' + date
        }
      },
      lcFormatValue: (value, config) => {
        let realResult = ''
        try {
          if (value !== undefined && value !== null) {
            // const valueYear = value.toString().substring(0, 4)
            // if (DateUtil.isYear(valueYear)) {
            //   if (valueYear >= 1970) {
            if (config.dateDisplayStyle === 'ONLY_YEAR') {
              if (
                DateUtil.isYear(value.toString()) ||
                DateUtil.isYearMonth(value.toString()) ||
                DateUtil.isYearMonth(value.toString(), '-') ||
                DateUtil.isYearMonthDay(value.toString()) ||
                DateUtil.isYearMonthDay(value.toString(), '-', '-') ||
                DateUtil.isYearMonthDayTime(value.toString(), '\\/', '\\/', '\\s', ':', ':') ||
                DateUtil.isYearMonthDayTime(value.toString(), '-', '-', '\\s', ':', ':')
              ) {
                realResult = value.toString().substring(0, 4)
              }
            } else if (config.dateDisplayStyle === 'YEAR_MONTH') {
              if (
                DateUtil.isYearMonth(value.toString()) ||
                DateUtil.isYearMonth(value.toString(), '-') ||
                DateUtil.isYearMonthDay(value.toString()) ||
                DateUtil.isYearMonthDay(value.toString(), '-', '-') ||
                DateUtil.isYearMonthDayTime(value.toString(), '\\/', '\\/', '\\s', ':', ':') ||
                DateUtil.isYearMonthDayTime(value.toString(), '-', '-', '\\s', ':', ':')
              ) {
                realResult = DateUtil.getDateValue(value, 'YEAR_MONTH')
              }
            } else if (config.dateDisplayStyle === 'ONLY_DATE') {
              if (
                DateUtil.isYearMonthDay(value.toString()) ||
                DateUtil.isYearMonthDay(value.toString(), '-', '-') ||
                DateUtil.isYearMonthDayTime(value.toString(), '\\/', '\\/', '\\s', ':', ':') ||
                DateUtil.isYearMonthDayTime(value.toString(), '-', '-', '\\s', ':', ':')
              ) {
                realResult = DateUtil.getDateValue(value, 'ONLY_DATE')
              }
            } else if (config.dateDisplayStyle === 'DATE_TIME') {
              if (
                DateUtil.isYearMonthDayTime(value.toString(), '\\/', '\\/', '\\s', ':', ':') ||
                DateUtil.isYearMonthDayTime(value.toString(), '-', '-', '\\s', ':', ':')
              ) {
                realResult = DateUtil.getDateValue(value, 'DATE_TIME')
              }
            }
          }
          //   }
          // }
        } catch (error) {
          realResult = ''
        }
        return realResult
      },
      lcValidateValue: (value, config) => {
        // const valueYear = value.toString().substring(0, 4)
        if (value === '') {
          return true
        }
        // if (DateUtil.isYear(valueYear)) {
        //   if (valueYear >= 1970) {
        //     if (
        //       DateUtil.isYear(value.toString()) ||
        //       DateUtil.isYearMonth(value.toString()) ||
        //       DateUtil.isYearMonth(value.toString(), '-') ||
        //       DateUtil.isYearMonthDay(value.toString()) ||
        //       DateUtil.isYearMonthDay(value.toString(), '-', '-') ||
        //       DateUtil.isYearMonthDayTime(value.toString(), '\\/', '\\/', '\\s', ':', ':') ||
        //       DateUtil.isYearMonthDayTime(value.toString(), '-', '-', '\\s', ':', ':')
        //     ) {
        //       return true
        //     }
        //   }
        // }
        if (
          DateUtil.isYear(value.toString()) ||
          DateUtil.isYearMonth(value.toString()) ||
          DateUtil.isYearMonth(value.toString(), '-') ||
          DateUtil.isYearMonthDay(value.toString()) ||
          DateUtil.isYearMonthDay(value.toString(), '-', '-') ||
          DateUtil.isYearMonthDayTime(value.toString(), '\\/', '\\/', '\\s', ':', ':') ||
          DateUtil.isYearMonthDayTime(value.toString(), '-', '-', '\\s', ':', ':')
        ) {
          return true
        }
        return false
      }
    }
  },
  editorConfig: [
    'INFO',
    'LABEL',
    'PLACEHOLDER',
    'DATEDISPLAYTYPE',
    'DATEDEFAULTVALUE',
    'WIDTH',
    'HIDDEN',
    'READONLY',
    'REQUIRED',
    'EDITONNEW',
    'UNIQUE'
  ],
  excludeEditorConfigInTable: ['WIDTH']
}

export default FormDateSelect
